const formatNumberHelper = (number) => {
  return number.toLocaleString()
}

export default {
  formatNumber: formatNumberHelper,
  formatOrdinal: (number) => {
    const floor = Math.floor(number)
    let modTen = floor % 10
    let modOneHundred = floor % 100

    if (modTen === 1 && modOneHundred !== 11) {
      return floor + 'st'
    }

    if (modTen === 2 && modOneHundred !== 12) {
      return floor + 'nd'
    }

    if (modTen === 3 && modOneHundred !== 13) {
      return floor + 'rd'
    }

    return formatNumberHelper(floor) + 'th'
  },
  formatPercent: (decimal) => {
    let formattedPercent

    if (decimal) {
      formattedPercent = `${(decimal * 100).toFixed(2)}%`
    } else {
      formattedPercent = '0.00%'
    }

    return formattedPercent
  },
}



// WEBPACK FOOTER //
// ./src/app/filters/numbers.js